<template>
  <base-draggable-modal
      name="edit_todolist"
      max-height="80vh"
      width="50vw"
      :fullscreen="$vuetify.display.xsOnly"
      ref="edit_todolist">
    <v-card rounded="xl">
      <base-modal>
        <template #header>
          <v-toolbar class="draggable_selector" flat color="secondary" density="compact">
            <v-toolbar-title class="text-primary">{{ $store.getters.translate(page.name) }}</v-toolbar-title>
            <v-spacer/>
            <base-action-button class="mr-5" :delete="true" @action="archive">
              <template #prepend><PhArchive style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
              {{ $store.getters.translate("delete") }}
            </base-action-button>
          </v-toolbar>
        </template>
        <template #content>
          <v-card-text>
            <v-autocomplete
                density="default"
                class="reg-normal text-primary"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-if="source_page === 'home'"
                v-model="record.project_management_id"
                :items="project_management"
                :return-object="false"
                item-value="value"
                item-title="text"
                hide-details
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('project') }}<strong>*</strong></span>
              </template>
            </v-autocomplete>
            <v-text-field
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.name"
                hide-details
                flat
                clearable>
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('task') }}<strong>*</strong></span>
              </template>
            </v-text-field>
            <v-text-field
                density="default"
                class="reg-normal text-primary mt-3"
                base-color="border-tertiary"
                bg-color="secondary"
                color="primary"
                v-model="record.due_date"
                hide-details
                flat
                clearable
                v-mask="'##-##-####'"
                placeholder="dd-mm-yyyy">
              <template #label>
                <span class="sm-normal text-subtle">{{ $store.getters.translate('due_date') }}</span>
              </template>
            </v-text-field>
          </v-card-text>
        </template>
        <template #footer>
          <v-card-text>
            <v-row>
              <v-col>
                <base-action-button :width="'100%'" @action="closeModal('edit_todolist')">
                  <template #prepend><PhX style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("cancel") }}
                </base-action-button>
              </v-col>
              <v-col>
                <base-action-button :background="true" :width="'100%'" @action="save">
                  <template #prepend><PhFloppyDisk style="vertical-align: middle; margin-right: 5px;" size="20" /></template>
                  {{ $store.getters.translate("save") }}
                </base-action-button>
              </v-col>
            </v-row>
          </v-card-text>
        </template>
      </base-modal>
    </v-card>
  </base-draggable-modal>
</template>

<script>
import BaseModal from "../../components/commonComponents/BaseModal";
import BaseDraggableModal from "../../components/commonComponents/BaseDraggableModal";
import helpFunctions from "../../plugins/helpFunctions";
import BaseActionButton from "../../components/commonComponents/BaseActionButton";
import {PhArchive, PhFloppyDisk, PhX} from "@phosphor-icons/vue";

export default {
  components: {
    BaseActionButton,
    BaseModal,
    BaseDraggableModal,
    PhFloppyDisk, PhX, PhArchive,
  },
  props: ["source_page"],
  data() {
    return {
      page: helpFunctions.pages.todolists,
      record: {},
      project_management: [],
    };
  },
  methods: {
    ...helpFunctions.modal_functions,
    async load(id) {
      this.record = {};
      this.openModal('edit_todolist');
      this.record = await helpFunctions.loadModel(this.$toast, this.page.name, id);
      if(this.source_page === 'home') {
        await this.getProjectManagement();
      }
    },
    async save() {
      if(await helpFunctions.saveModel(this.$toast, this.page.name, this.record)) {
        this.$emit('refresh');
        this.closeModal('edit_todolist');
      }
    },
    async archive() {
      this.$confirm(this.$store.getters.translate("delete_confirmation")).then(async (res) => {
        if (res) {
          await helpFunctions.deleteModel(this.$toast, this.page.name, this.record.id);
          this.$emit('refresh');
          this.closeModal('edit_todolist');
        }
      });
    },
    async getProjectManagement() {
      this.project_management = await helpFunctions.getAdditionalModelsForDropdowns("projectmanagement", "id", ["name"]);
    },
  },
};
</script>

<style scoped>
.link {
  display: block !important;
  font-size: 14px;
  margin-top: 5px !important;
  margin-bottom: 10px !important;
}
</style>